import { Component, Injector } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ApAlertService } from 'webcommon/core-ui';

import {
  FcFilterConfigurationFieldType,
  FcGenericFilterModalBaseComponent,
} from '../../generic/index';

@Component({
  providers: [ApAlertService],
  selector: 'fc-ansi-filter-modal',
  templateUrl: './fc-ansi-list-filter-modal.component.html',
})
export class FcAnsiListFilterModalComponent extends FcGenericFilterModalBaseComponent {
  public override baseId = 'fc-ansi-filter';

  // Form Controls
  public ansiCodeControl = new FormControl('');
  public externalIdControl = new FormControl('');
  public nameControl = new FormControl('');

  // Form Group
  public form = new FormGroup({
    ansiCode: this.ansiCodeControl,
    externalId: this.externalIdControl,
    name: this.nameControl,
  });

  constructor(injector: Injector) {
    super(injector);

    this.config.set('ANSICode', { type: FcFilterConfigurationFieldType.Single, control: this.ansiCodeControl });
    this.config.set('ExternalID', { type: FcFilterConfigurationFieldType.Single, control: this.externalIdControl });
    this.config.set('Name', { type: FcFilterConfigurationFieldType.Single, control: this.nameControl });
  }
}
